<div class="row">
  <div class="col-xs-12 col-sm-12 col-md-8 p-0 m-0">
    <app-user-header [selectedHeader]="userData?.header" [tableCategory]="creditInvoice"></app-user-header>


    <section class="col-md-8 col-sm-8 pay-section float-left account-reg-section">

      <div class="
        col-xs-12 col-sm-12 col-md-12
        Registration-split
        confirmation-split
      ">
        <h3 class="pdp-title">
          <img src="//icons/confirmation-positive-green.png" alt="">
          {{("userRegistration.userConfirmation.title" | cxTranslate: {name : userName})}}
        </h3>

        <span class="confirmation-txt">
          {{ ("userRegistration.userConfirmation.content" | cxTranslate: {email : email }) }}
          <br />
          <br />
          {{"userRegistration.userConfirmation.content2" | cxTranslate}}
        </span><br>

        <div class="invoice-btngrps">
          <button type="button" class="btn-primary" data-di-id="di-id-41a05d18-6b04a424"
            [routerLink]="['/Open-Catalogue/c/1']">
            {{ "userRegistration.userConfirmation.catalog_button" | cxTranslate }}
          </button>
        </div>
      </div>
    </section>
  </div>

  <div class="col-xs-12 col-sm-12 col-md-4 needCls needCls2">
  </div>
</div>
